import { getAuthenticationInformationQueryKey, } from "../api";
import { useQueryClient } from "@tanstack/react-query";
/**
 * A hook that provides utilities for managing security settings.
 * Allows optimistically updating verification method status (password, MFA, passkey)
 * while also triggering a server revalidation.
 */
export function useSecuritySettings() {
    const client = useQueryClient();
    const update = (method, isSetUp) => {
        const queryKey = getAuthenticationInformationQueryKey();
        // Optimistic update
        client.setQueriesData({ queryKey, exact: false }, (data) => {
            if (!data) {
                return data;
            }
            return {
                ...data,
                data: {
                    ...data.data,
                    verificationMethods: {
                        ...data.data.verificationMethods,
                        [method]: { ...data.data.verificationMethods[method], isSetUp },
                    },
                },
            };
        });
        // Also validate it with the server
        client.invalidateQueries({
            queryKey: getAuthenticationInformationQueryKey(),
            exact: false,
        });
    };
    return { update };
}
//# sourceMappingURL=use-security-settings.js.map